import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import { useDispatch } from "react-redux";
import ExploreMotionButton from "./ExploreMotionButton";
import DashboardNotificationDropdown from "./DashboardNotificationDropdown";
import DashboardProfileDropdown from "./DashboardProfileDropdown";
import DashboardStreakButton from "./DashboardStreakButton";
import StoreChoiceModal from "../../DashboardCourses/components/StoreChoiceModal/StoreChoiceModal";
import { navigateToExploreMotion } from "../../DashboardLayout/dashboardNavigation";
import "./DashboardHeaderActions.css";

const DashboardHeaderActions = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const [isStoreChoiceOpen, setIsStoreChoiceOpen] = useState(false);

  const handleOpenStoreModal = () => {
    setIsStoreChoiceOpen(true);
  };

  const handleCloseStoreModal = () => {
    setIsStoreChoiceOpen(false);
  };

  const handleSelectOldStore = () => {
    setIsStoreChoiceOpen(false);
    navigateToExploreMotion(history, dispatch, { storeVersion: "classic" });
  };

  const handleSelectNewStore = () => {
    setIsStoreChoiceOpen(false);
    navigateToExploreMotion(history, dispatch, { storeVersion: "new" });
  };

  return (
    <div className="dashboard-header-actions">
      <DashboardStreakButton />

      <ExploreMotionButton
        onClick={() => navigateToExploreMotion(history, dispatch)}
      />

      <div className="dashboard-header-actions__utilities">
        <DashboardNotificationDropdown />
        <DashboardProfileDropdown />
      </div>

      <StoreChoiceModal
        isOpen={isStoreChoiceOpen}
        onClose={handleCloseStoreModal}
        onSelectOldStore={handleSelectOldStore}
        onSelectNewStore={handleSelectNewStore}
      />
    </div>
  );
};

export default DashboardHeaderActions;
